import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ExpertLetter } from "../clients/clientsSlice";

export interface FormsSliceData {
  expertLettersForms: ExpertLetter[] | null;
}

const formsInitialData: FormsSliceData = {
  expertLettersForms: null
};
export interface FormsReducer {
  forms: FormsSliceData;
}

export const formsSlice = createSlice({
  name: "forms",
  initialState: formsInitialData,
  reducers: {
    setExpertLetters: (state, action: PayloadAction<ExpertLetter[] | null>) => {
      state.expertLettersForms = action.payload;
    },
    updateExpertLetter: (
      state,
      action: PayloadAction<Partial<ExpertLetter>>
    ) => {
      const { uid, ...updatedFields } = action.payload;
      if (uid) {
        const index = state.expertLettersForms?.findIndex(
          (expert) => expert.uid === uid
        );
        if (index !== undefined) {
          state.expertLettersForms![index] = {
            ...state.expertLettersForms![index],
            ...updatedFields
          };
        }
      }
    },
    addExpertLetter: (state, { payload }: PayloadAction<ExpertLetter>) => {
      state.expertLettersForms?.push(payload);
    },
    clearExpertLetters: (state) => {
      state.expertLettersForms = [];
    }
  }
});

export const {
  setExpertLetters,
  addExpertLetter,
  clearExpertLetters,
  updateExpertLetter
} = formsSlice.actions;

export default formsSlice.reducer;
